import { gql } from "apollo-boost";

export const GET_PURCHASE_ORDER_DETAIL = gql`
query Purchaseorderdetails(
  $where: PurchaseOrderDetailWhereInput!
  $orderBy: OrderByInput
  $skip: Int
  $limit: Int
) {
  purchaseorderdetails(
    where: $where
    orderBy: $orderBy
    skip: $skip
    limit: $limit
  ) {
    total
    data {
      id
      totalPrice
      currency
      amount
      customerName
      status
      customerLastName
      staff
      staffLastname
      village
      district
      province
      code
      phone
      isSale
      createdAt
      sumPriceUsd
      totalPrice
      sumPriceBaht
      sumPrice
      rateBaht
      rateUsd
      lot {
        id
        survivalNumber
      }
      shop {
        id
        address {
          village
          province
          district
        }
        image
      }
      purchaseorders {
        id
        amount
        phone
        productName
        currency
        price
        totalPrice
        totalPriceBaht
        totalPriceUsd
        rateBaht
        rateUsd
        type
        isPaymented
        isDeleted
        note
        mfg
        exp
        stock {
          id
          currency
          price
          originPrice
          unit
          unitId {
            name
          }
          category {
            name
          }
        }
      }
    }
  }
}

`